import type { IconProps } from './types';

export const DotsVerticalIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M11 3H13V5H11V3Z" fill={color} />
      <path d="M11 11H13V13H11V11Z" fill={color} />
      <path d="M11 19H13V21H11V19Z" fill={color} />
      <path d="M11 3H13V5H11V3Z" stroke={color} strokeWidth="2" />
      <path d="M11 11H13V13H11V11Z" stroke={color} strokeWidth="2" />
      <path d="M11 19H13V21H11V19Z" stroke={color} strokeWidth="2" />
    </svg>
  );
};
